import { RootState } from 'store/rootReducer';

export const selectEditorMode = (state: RootState) => state.editorState.editorLoadSettings.mode;

export default {
    selectEditorMode,
};
